import { render, staticRenderFns } from "./universal_report_by_flat.vue?vue&type=template&id=369663f0&scoped=true&"
import script from "./universal_report_by_flat.vue?vue&type=script&lang=js&"
export * from "./universal_report_by_flat.vue?vue&type=script&lang=js&"
import style0 from "./universal_report_by_flat.vue?vue&type=style&index=0&id=369663f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369663f0",
  null
  
)

export default component.exports